import { useHistory } from 'react-router';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// app
import { multipartAdminAxios } from '../../admin.api';
import { CLIENT_OFFICE_LIST, OPERATIONAL_CLIENTS } from '../../queryKeys';
import * as utils from 'utils';
import config from 'config';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { enqueueNotification, hideModal } from 'stores';

export const useCreateOperationalClient = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const history = useHistory();

  const handleSettled = (data) => {
    dispatch(hideModal());
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.useCreateOperationalClient',
      message: 'API fetch error (admin.post)',
    };
    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    dispatch(enqueueNotification('notification.admin.parentClientPostFail', 'error'));
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_CLIENTS);
    queryClient.invalidateQueries(CLIENT_OFFICE_LIST);

    history.push(`${config.routes.admin.operationalClients}/${data?.id}`);

    dispatch(
      enqueueNotification('notification.admin.parentClientSuccess', 'success', {
        data: { clientName: data?.name },
      })
    );
  };

  return useMutation(
    async (newParentClient) => {
      let form = new FormData();
      form.append('name', newParentClient.name);
      if (!isEmpty(newParentClient?.logo)) {
        newParentClient.logo.forEach((file) => form.append('logo', file));
      }

      if (!utils.generic.isValidObject(newParentClient)) {
        throw new Error('Invalid operational client request body');
      }

      return await multipartAdminAxios.post('client/operational', form);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: handleSettled,
    }
  );
};
